import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { AnagraficaForm } from '../../../form/anagrafica-form';
import { AnagraficaResponse } from '../../../models/dto/anagrafica-response';
import { Parte } from '../../../models/parte';


import { FormValidationService } from '../../../services/form-validation.service';
import { ParteAdapter } from './parte-adapter';

declare var closeModal: any;

@Component({
    selector: 'div [parte-anagrafica-form]',
  templateUrl: '../../../form/anagrafica-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ParteAnagraficaUpdateComponent extends AnagraficaForm implements OnInit {
  private parte: Parte;
  private urlUpdate: string;
  private tipoPratica: string;

  @Output() onReturn: EventEmitter<Parte> = new EventEmitter<Parte>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }
  ngOnInit() {
    this.setTitle('Modifica parte - Anagrafica');
    this.isInserimento(false);
  }

  getAdapter(): Parte {
    return new ParteAdapter(this.parte).parte;
  }

  getRequest(request: Parte) {
    // this.operationService.updateParteToAnagrafica(this.urlUpdate, request).subscribe(response => this.sezioneControparteUpdated(response));
    this.operationService.updateAnagraficaElement(request).subscribe(response => this.sezioneControparteUpdated(response));
  }

  sezioneControparteUpdated(response: AnagraficaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.anagrafiche[0] as Parte);
    }
  }

  inizializza(urlUpdate: string, parte: Parte, tipoPratica,  idTipoFascicolo, isControparti: boolean = false) {
    this.tipoPratica = tipoPratica;
    this.idTipoFascicolo = idTipoFascicolo;
    this.parte = parte;
    this.isControparti = isControparti;
    this.populateSelect();
    this.createForm();
    this.urlUpdate = urlUpdate;
  }

  hasConvenzione(): boolean {
    return false;
  }

  hasTariffa(): boolean {
    return false;
  }

  hasDipendete(): boolean {
    return true;
  }

  hasMatricola(): boolean {
    return true;
  }

  hasAmbitiCompetenza(): boolean {
    return false;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }
}
